import { render, staticRenderFns } from "./commerce-view-btns.vue?vue&type=template&id=7dbf83df"
import script from "./commerce-view-btns.vue?vue&type=script&lang=js"
export * from "./commerce-view-btns.vue?vue&type=script&lang=js"
import style0 from "./commerce-view-btns.vue?vue&type=style&index=0&id=7dbf83df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports